import toast from 'utils/toast'
import institutionAPI from 'services/institutionAPI'

import { NotificationFilter, Pagination } from 'types'

type Params = {
  filters?: {
    filter?: NotificationFilter
    pagination?: Pagination
  }
}

export default async function readNotifications({ filters }: Params) {
  const response = await institutionAPI({
    method: 'POST',
    url: '/notification/notification/notifications',
    data: filters || {
      filter: {},
      pagination: {
        page: 1,
        limit: 0,
      },
    },
  })

  if (!response?.header?.success) {
    toast.error(response?.header?.message)
  }

  return response
}
